import React from 'react';

export default () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 1000 1000"
    enableBackground="new 0 0 1000 1000"
    //    xml:space="preserve"
  >
    <path
      style={{ fill: 'currentColor' }}
      d="M359.3,499.7c0-78.3,63.5-141.8,141.7-141.8l0,0c78.3,0,141.7,63.4,141.7,141.8l0,0
	c0,78.3-63.5,141.7-141.7,141.7l0,0C422.8,641.4,359.3,578,359.3,499.7L359.3,499.7z M365.5,499.7c0.2,74.9,60.7,135.4,135.5,135.5
	l0,0c74.8,0,135.6-60.7,135.6-135.5l0,0c-0.1-74.9-60.7-135.5-135.6-135.6l0,0C426.2,364.1,365.5,424.8,365.5,499.7L365.5,499.7z"
    />
    <path
      style={{ fill: 'currentColor' }}
      d="M523.5,499.7c0,12.3-10.1,22.3-22.4,22.3c-12.3,0-22.4-10-22.4-22.3c0-12.4,10-22.4,22.4-22.4
	C513.4,477.3,523.5,487.3,523.5,499.7z"
    />
    <g>
      <path
        fill="none"
        d="M501.1,314.8c-102.2,0-184.9,82.8-184.9,184.9c0,52.2,21.7,99.2,56.5,132.8c-0.2-0.2-0.4-0.4-0.6-0.6
		l-48.2,52.1c16.8,16.2,35.8,30.1,56.6,41.3l34.8-62l0,0c25.7,13.5,54.9,21.2,85.9,21.2c102.1,0,184.9-82.8,184.9-184.9
		c0-49.4-19.5-94.2-51-127.3l48.5-52.2c-16.5-16.7-35.2-31.2-55.7-42.9l-34.2,62.4C566.3,323.9,534.8,314.8,501.1,314.8z"
      />
      <path
        fill="none"
        d="M262.4,750.5l-49.2,53.2c26.2,24.8,55.4,46.3,87.3,63.7l35.5-63.2C309.2,789.6,284.5,771.4,262.4,750.5z"
      />
      <path
        fill="none"
        d="M745.1,253.8l49.3-53.1c-26.3-25.8-56-48.2-88.3-66.4l-34.8,63.6C698.3,213.3,723.1,232.1,745.1,253.8z"
      />
      <path
        fill="none"
        d="M689.7,313.4l49.1-52.8c-21.4-21.3-45.6-39.6-72-54.6l-34.6,63.2C653.3,281.3,672.7,296.2,689.7,313.4z"
      />
      <path
        fill="none"
        d="M317.6,690.8l-48.9,52.9c21.5,20.5,45.6,38.2,71.9,52.5l35.3-62.8C354.5,721.9,334.9,707.5,317.6,690.8z"
      />
      <path
        style={{ fill: 'currentColor' }}
        d="M245.1,499.7c0,72.4,30.2,137.8,78.7,184.4l48.2-52.1c0.2,0.2,0.4,0.4,0.6,0.6
		c-34.8-33.6-56.5-80.7-56.5-132.8c0-102.1,82.7-184.9,184.9-184.9c33.7,0,65.2,9.1,92.4,24.9l34.2-62.4
		c-37.4-21.4-80.6-33.6-126.6-33.6C360,243.6,245.1,358.5,245.1,499.7z"
      />
      <path
        style={{ fill: 'currentColor' }}
        d="M686,499.7c0,102.1-82.8,184.9-184.9,184.9c-31,0-60.2-7.7-85.9-21.2l0,0l-34.8,62
		c36,19.3,77.1,30.3,120.7,30.3c141.2,0,256-114.8,256-256c0-69.9-28.2-133.3-73.7-179.5L635,372.3C666.5,405.5,686,450.3,686,499.7
		z"
      />
      <path
        style={{ fill: 'currentColor' }}
        d="M163.9,499.7c0,95.9,40.3,182.6,104.8,244.1l48.9-52.9c-50.3-48.3-81.7-116.1-81.7-191.2
		c0-146.3,119-265.2,265.2-265.2c47.6,0,92.3,12.7,131,34.8l34.6-63.2c-49-27.7-105.5-43.7-165.6-43.7
		C315.2,162.4,163.9,313.7,163.9,499.7z"
      />
      <path
        style={{ fill: 'currentColor' }}
        d="M766.4,499.7c0,146.3-119,265.2-265.2,265.2c-45.3,0-87.9-11.4-125.3-31.5l-35.3,62.8
		c47.8,26,102.5,40.7,160.6,40.7c186,0,337.3-151.3,337.3-337.3c0-93.3-38.1-177.9-99.6-239.1l-49.1,52.8
		C737.1,361.3,766.4,427.1,766.4,499.7z"
      />
      <path
        style={{ fill: 'currentColor' }}
        d="M847.6,499.7c0,191.1-155.4,346.5-346.5,346.5c-59.7,0-116-15.2-165.1-41.9l-35.5,63.2
		c59.6,32.6,128,51.2,200.6,51.2c231,0,419-188,419-419c0-117-48.2-222.8-125.7-298.9l-49.3,53.1
		C808.4,316.7,847.6,403.6,847.6,499.7z"
      />
      <path
        style={{ fill: 'currentColor' }}
        d="M82.1,499.7c0,119.6,50.5,227.6,131.1,304l49.2-53.2c-66.3-63.2-107.8-152.2-107.8-250.8
		c0-191.1,155.4-346.5,346.5-346.5c61.8,0,119.8,16.3,170.1,44.8l34.8-63.6c-60.6-34.2-130.5-53.7-204.9-53.7
		C270.1,80.6,82.1,268.6,82.1,499.7z"
      />
      <path
        style={{ fill: 'currentColor' }}
        d="M848.8,142.3L800.7,194c79.3,77.8,128.7,186,128.7,305.7c0,236.1-192.1,428.2-428.2,428.2
		c-74.3,0-144.2-19-205.1-52.4l-35.6,63.4c71.2,39.1,152.9,61.4,239.8,61.5c276.1,0,500.1-223.9,500.1-500
		C1000.2,359.9,942.1,233.1,848.8,142.3z"
      />
      <path
        style={{ fill: 'currentColor' }}
        d="M72.9,499.7C72.9,263.5,265,71.4,501.1,71.4c76,0,147.4,20,209.4,54.9l33.9-62
		C674.4,24.9,594,1.9,508.3,0.5h-8.1C225.7,1,3.3,221.7,0.3,495.7l0,0v4.8C0.6,643.8,61,772.8,157.6,863.9l49.4-53.4
		C124.5,732.4,72.9,621.9,72.9,499.7z"
      />
    </g>
  </svg>
);
